/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_Totp_DescriptionInputs */



/**
* | output |
* | --- |
* | "Use a TOTP app like 1Password, Authy, or Google Authenticator instead of your recovery code when signing in via email link." |
*
* @param {Profile_Security_Totp_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_totp_description = /** @type {((inputs?: Profile_Security_Totp_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_Totp_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwende eine TOTP-App wie 1Password, Authy oder Google Authenticator anstelle deines Wiederherstellungscodes beim Anmelden per E-Mail-Link.")
	return /** @type {LocalizedString} */ ("Use a TOTP app like 1Password, Authy, or Google Authenticator instead of your recovery code when signing in via email link.")
});